export const InitialResponseTabs = [
  'Overview',
  'Objectives & Actions',
  'Incident Roster',
  'Resources',
  'Safety Analysis',
  'Incident Briefing',
  'Reports',
] as const;

export type InitialResponseTabsType = (typeof InitialResponseTabs)[number];
